import type { Post, Tag } from "@package/ui-gql/index-data-access";
import { createContext, useContext } from "react";
import { type FlyoutProps } from "../../../utils/flyout-props";

export type FlyoutSearchDisplayType = "tags" | "posts";

export type FlyoutSearchContextState = {
  backgroundColorPrimary: string;
  backgroundColorSecondary: string;
  colorPrimary: string;
  colorSecondary: string;
  displayType: FlyoutSearchDisplayType;
  error: boolean;
  hideKeyboard: boolean;
  headerMedia?: string;
  large: boolean;
  loading: boolean;
  posts: Post[];
  screen?: FlyoutProps["screen"];
  tags: Tag[];
  tagSelected?: Tag;
  tagSelectionEnabled: boolean;
  text?: string;
  onSelectTag: (tag: Tag) => void;
  onCloseTag: () => void;
};

export const defaultFlyoutSearchContextState: FlyoutSearchContextState = {
  backgroundColorPrimary: "#909090",
  backgroundColorSecondary: "#000000",
  colorPrimary: "#ffffff",
  colorSecondary: "#ffffff",
  displayType: "posts",
  error: false,
  hideKeyboard: false,
  headerMedia: undefined,
  large: false,
  loading: false,
  posts: [],
  tags: [],
  tagSelected: undefined,
  tagSelectionEnabled: false,
  text: undefined,
  onSelectTag: () => {},
  onCloseTag: () => {},
};

export const FlyoutSearchStateContext = createContext<FlyoutSearchContextState>(
  defaultFlyoutSearchContextState,
);
export const useFlyoutSearchState = () => useContext(FlyoutSearchStateContext);
